import Guide from "../Guid";
import Camera from "../Camera";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import React, {useContext, useRef, useState} from "react";
import CompareFaceGuide_image from "../../images/guide/compareFaces_guide.png";
import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import ProgressLoading from "../loading/ProgressLoading";
import UserAuthenticationContext from "../../tools/contexts/authenticatonService/UserAuthenticationContext";
import REQUEST_URLS from "../../tools/defaults/requestUrl";

const CompareFaceGuidSlides = [
    {
        image: CompareFaceGuide_image,
        title: "ونیفای",
        subTitle: "عکس از چهره",
        texts: `در شرایط نوری مناسب  بدون عینک و ماسک از چهره خود عکس بگیرید .  `,

    },
]
const CompareFaces = () => {
    const userAuthenticationContext = useContext(UserAuthenticationContext);
    const CompareFaceWebcam = useRef(null);
    const [showGuide, setShowGuide] = useState(true);
    const [isLoading, setLoading] = useState(false)
    const [step, setStep] = useState(1);
    const [image, setImage] = useState('');

    const handlePrev = () => {
        setStep(step - 1);
    }
    const onFaceCapture = (base64Image) => {
        setImage(base64Image);
        setStep(step + 1)
    }

    const handleCompareFace = () => {
        setLoading(true)
        handleGenerateUuid('CompareFaces', userAuthenticationContext.token).then((uuid) => {
            Api.post(REQUEST_URLS.DIVAR_INTERNAL_AUTH.COMPARE_FACES, {
                pid: userAuthenticationContext.pid,
                uuid: uuid,
                Image2: image.replace('data:image/jpeg;base64,', ''),
            }, {
                headers: {
                    "Authorization": `Bearer ${userAuthenticationContext.token}`
                },
            }).then((response) => {
                const {data, hasError, status, message} = response;

                if (!hasError) {
                    userAuthenticationContext.handleGetProcess(userAuthenticationContext.pid)
                } else {
                    userAuthenticationContext.handleError({
                        message, status, data, callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای سرویس',
                                pid: userAuthenticationContext.pid,
                                onConfirm: () => {
                                    Reoverlay.hideModal();
                                    if (data?.can_reset) {
                                        userAuthenticationContext.handleReset(userAuthenticationContext.pid)
                                    }
                                },
                                showConfirmButton: data?.can_reset,
                                confirmButtonText: 'ویرایش اطلاعات',
                                showCancelButton: true,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                onCancel: () => {

                                    Reoverlay.hideModal();
                                    setShowGuide(false)
                                    setStep(1);

                                }
                            })
                        }
                    })

                }

            }).catch(() => {
            }).finally(() => {
                setLoading(false)
            })
        }).catch(() => {

        })
    }
    if (isLoading) {
        return <ProgressLoading type="CompareFaces" duration={30} showProgress={false} theme="green"
                                text={'در حال احراز هویت تصویری'}/>
    }

    return <div className="w-11/12 mx-auto md:w-6/12 mt-5   lg:w-5/12 xl:w-3/12">
        {showGuide && step === 1 &&
            <Guide imageClass={'w-8/12  md:w-8/12 lg:w-3/12 xl:w-2/12 '} closeGuid={() => setShowGuide(false)}
                   slides={CompareFaceGuidSlides}/>}
        {!showGuide && step === 1 &&
            <Camera galleryEnable={false} text="در شرایط نوری مناسب از چهره خود عکس بگیرید." title={'عکس چهره کاربر'}
                    handleShowGuid={() => {
                        setShowGuide(true)
                    }} faceMode="user" webcamRef={CompareFaceWebcam} onCapture={onFaceCapture} isVideo={false}
                    type="face"/>}
        {!showGuide && step === 2 && <>
            <div className="grid gap-1 grid-cols-1">
                <img className="w-full h-auto rounded-lg" src={image} alt=""/>
            </div>
            <BottomButtonWrapper grid={2}>
                <Button onClick={handleCompareFace} className={"w-full"} rounded="rounded-lg"
                        theme="green">تایید</Button>
                <Button onClick={() => {
                    handlePrev()
                }} className={"w-full"} rounded="rounded-lg" theme="light">تلاش مجدد</Button>
            </BottomButtonWrapper>
        </>}

    </div>
}
export default CompareFaces;